import tokensInfo from './tokensInfo'
import kulapABI from './abi/kulap.json'
import ERC20ABI from './abi/ERC20ABI.json'
import bignumber from '@/utils/bignumber'

export const ENV = process.env.ENV
export const ETH_NETWORK = process.env.ETH_NETWORK
export const TOKENS_INFO = tokensInfo
export const KULAP_MAINNET_ADDR = '0x3833cf2972394d636b1C5b80d34FeE1F17175b77'
export const KULAP_KOVAN_ADDR = '0xf87716d541dd7581161268688884a4b77cd56f86'
export const KULAP_ABI = kulapABI
export const ERC20_ABI = ERC20ABI
export const DEX_TOKEN_APPROVE_AMOUNT = '115792089237316195423570985008687907853269984665640564039457584007913129639935'
export const DEX_TOKEN_APPROVE_GAS_LIMIT = bignumber(100000)
export const BIGNUMBER_ZERO = bignumber(0)
export const RECAPTCHA_SITE_KEY = '6Ld_pMUZAAAAAM5Pajn7kxKwQRbJGoqIRb3axu7Y'
export const GOOGLE_CLIENT_ID = '137588238337-m5k8a57lnmsikhp9an1oq5fa9kp4o1gg.apps.googleusercontent.com'
export const PARTNER_INDEX = 0
export const PLATFORM_FEE = 0
export const DEFAULT_PRICE_SLIPPAGE = 3
// KYC
export const KYC_PICTURE_FILE_SIZE_LIMIT_IN_MB = 20
export const KYC_DOC_FILE_SIZE_LIMIT_IN_MB = 20



// WEBPACK FOOTER //
// ./src/constants/index.js